import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import serviziData from '../data/servizi-data';
import '../styles/about.css';

const About = () => {
	const { t } = useTranslation();
	const servicesTranslations = t('servicesData', { returnObjects: true });

	return (
		<section id="about" className="services-section sect-pt4 route">
			<div className="container-modern">
				<div className="title-box text-center">
					<span className="section-badge">{t('about.badge')}</span>
					<h3 className="title-a">{t('about.title')}</h3>
					<p className="services-intro-text">
						{t('about.intro')}
					</p>
					<div className="line-mf"></div>
				</div>

				<div className="grid grid-3">
					{serviziData.map((servizio, index) => (
						<Link
							to={`/servizi/${servizio.slug}`}
							key={servizio.id}
							className="service-card card-modern"
							style={{ textDecoration: 'none' }}
						>
							<div className="service-card-icon">
								<iconify-icon icon={servizio.icon}></iconify-icon>
							</div>
							<h4 className="service-card-title">{servicesTranslations[index]?.title || servizio.title}</h4>
							<p className="service-card-description">
								{servicesTranslations[index]?.shortDescription || servizio.shortDescription}
							</p>
							<span className="service-card-link">
								{t('about.learnMore')}
								<iconify-icon icon="carbon:arrow-right"></iconify-icon>
							</span>
						</Link>
					))}
				</div>
			</div>
		</section>
	);
};

export default About;
